<ng-template #itemTemplate>
  <rt-icon *ngIf="icon" [name]="icon" [class.active]="iconActive" class="item-icon"></rt-icon>
  <rt-icon
    *ngIf="draggable && !sidebarMinimized"
    [class.active]="iconActive"
    class="drag-icon"
    name="drag-vertical"
    [size]="dragIconSize"
  ></rt-icon>
  <ng-container *ngIf="!sidebarMinimized">
    <div class="top-wrapper">
      <div #itemName class="item-name" [class.with-icon]="icon">
        {{ name }}
      </div>
      <div *ngIf="bottomOutlet" class="bottom-outlet">
        <ng-container
          *ngTemplateOutlet="bottomOutlet; context: bottomOutletContext!"
        ></ng-container>
      </div>
    </div>
    <div
      *ngIf="rightOutlet"
      #rightOutletOrigin="rtOverlayOrigin"
      rt-overlay-origin
      class="right-outlet"
    >
      <ng-container *ngTemplateOutlet="rightOutlet; context: rightOutletContext!"></ng-container>
    </div>
  </ng-container>
</ng-template>

<div
  *ngIf="!url"
  [rtTooltip]="name"
  [rtTooltipEnabled]="(sidebarMinimized && tooltipEnabled) || isTooltipEnabledFn"
  [class.minimized]="sidebarMinimized"
  [class.large]="bottomOutlet && !sidebarMinimized"
  [class.active]="active"
  [class.draggable]="draggable"
  [class.light]="light"
  [class.hoverable]="hoverable"
  [class.right-outlet-active]="rightOutlet"
  rtTooltipPosition="right"
  class="wrapper"
>
  <div *ngIf="activeStateIndicatorEnabled" class="active-state-indicator"></div>
  <ng-container [ngTemplateOutlet]="itemTemplate"></ng-container>
</div>

<a
  *ngIf="url"
  [routerLink]="url"
  [queryParams]="queryParams"
  routerLinkActive="active"
  [rtTooltip]="name"
  [rtTooltipEnabled]="(sidebarMinimized && tooltipEnabled) || isTooltipEnabledFn"
  [class.minimized]="sidebarMinimized"
  [class.large]="bottomOutlet && !sidebarMinimized"
  [class.active]="active"
  [class.draggable]="draggable"
  [class.light]="light"
  [class.hoverable]="hoverable"
  [class.right-outlet-active]="rightOutlet"
  [rtcAnalyticsTrack]="analyticsEvent"
  [rtcAnalyticsTrackData]="analyticsEventData"
  rtTooltipPosition="right"
  class="wrapper"
>
  <div *ngIf="activeStateIndicatorEnabled" class="active-state-indicator"></div>
  <ng-container [ngTemplateOutlet]="itemTemplate"></ng-container>
</a>
